<template>
  <div class="row">
      <div class="col-sm-4 nopads pr-2 mb-1">
          <div class="mb-3">
              <select
                  id="customer"
                  v-model="roleId"
                  class="form-select form-select-sm"
              >
                  <option :value="-1" disabled>
                      {{ $t('users.select_profile') }}
                  </option>
                  <option
                      v-for="r in roles"
                      :key="r.id"
                      :value="r.id"
                  >
                      {{ getRoleName(r.role) }}
                  </option>
              </select>
          </div>
      </div>
      <div
        v-if="isAdmin"
        class="col-sm-4 nopads pr-2 mb-1"
      >
          <div class="mb-1">
              <select
                  id="customer"
                  v-model="companyId"
                  class="form-select form-select-sm"
              >
                  <option :value="-1" disabled>
                      {{ $t('users.select_company') }}
                  </option>
                  <option
                      v-for="c in companies"
                      :key="c.id"
                      :value="c.id"
                  >
                      {{ c.name }}
                  </option>
              </select>
          </div>
      </div>
      <div class="col-sm-3">
          <div class="mb-1">
              <input
                  id="info"
                  v-model="info"
                  type="text"
                  class="form-control form-control-sm"
                  :placeholder="$t('users.role_assign_info')"
              />
          </div>
      </div>
      <div class="col-sm-1 nopads pl-2">
        <button
          v-if="userRightUpdate.id < 1"
          class="btn btn-success btn-sm mr-1"
          :disabled="roleId < 0 || (companyId < 0 && isAdmin)"
          @click.stop="addUserRight"
        >
          <i class="fa fa-plus" />
        </button>
      </div>
  </div>
</template>

<script>
import {userHelper} from '../mixins/UserMixin'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'UserRightSelector',
    mixins: [userHelper, restApi],
    props: {
        companies: {
            type: Array,
            default: function () {
                return []
            }
        },
        roles: {
            type: Array,
            default: function () {
                return []
            }
        },
        userRight: {
            type: Object,
            default: null
        },
        isAdmin: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            userRightUpdate: {id: -1, role: {id: -1}, company: {id: -1}},
            roleId: -1,
            companyId: -1,
            info: ""
        }
    },

    mounted: function () {
        if (this.userRight) {
            this.userRightUpdate = this.userRight
            this.roleId = this.userRightUpdate.role.id
            this.companyId = this.userRightUpdate.company.id
            this.info = this.userRightUpdate.info
        }
    },

    methods: {
        addUserRight: function () {
            this.userRightUpdate.role = this.roles.find(item => item.id === this.roleId)
            this.userRightUpdate.company = this.companies.find(item => item.id === this.companyId)
            this.userRightUpdate.info = this.info
            this.$emit('addUserRight', this.userRightUpdate)
        },
        reset: function () {
            this.userRightUpdate = {id: -1, role: {id: -1}, company: {id: -1}, info: ""}
        },
        addUnAddedUserRight: function () {
            if(this.roleId !== -1) {
                this.userRightUpdate.role = this.roles.find(item => item.id === this.roleId)
                this.userRightUpdate.company = this.companies.find(item => item.id === this.companyId)
                this.userRightUpdate.info = this.info
                return this.userRightUpdate
            }
        }
    }
}
</script>
